import { Box, Button, Grid, Link, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';

function SearchFilterForm(props) {
  const { values, errors, loading, onChange, onClear, onSearch } = props;

  const formValues = values || {
    username: '',
    email: '',
    businessName: '',
    contactName: '',
  };

  const formErrors = errors || {};

  const hasSearchCriteria =
    formValues.username || formValues.email || formValues.businessName || formValues.contactName;

  // 1 column on phones, 2 on tablets, 4 across on desktop. The actions sit on their own
  // row until there is enough width (xl) to fit them beside the fields.
  const fieldGridProps = { xs: 12, sm: 6, lg: 3, xl: 2.5 };

  return (
    <Grid container spacing={{ xs: 1.5, sm: 2 }} alignItems="flex-start">
      <Grid item {...fieldGridProps}>
        <Typography
          sx={{
            fontSize: '14px !important',
            fontWeight: 700,
            mb: 1,
            color: '#444444',
          }}
        >
          Username
        </Typography>

        <TextField
          fullWidth
          sx={{
            '& .MuiInputBase-input': {
              fontFamily: 'Arial',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#313131',
            },
            '& .MuiInputBase-input::placeholder': {
              fontFamily: 'Arial',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#808285',
              opacity: 1,
            },
          }}
          placeholder="Username"
          value={formValues?.username || ''}
          onChange={(e) => onChange('username', e.target.value)}
        />
      </Grid>

      <Grid item {...fieldGridProps}>
        <Typography
          sx={{
            fontSize: '14px !important',
            fontWeight: 700,
            mb: 1,
            color: '#444444',
          }}
        >
          Email
        </Typography>

        <TextField
          fullWidth
          sx={{
            '& .MuiInputBase-input': {
              fontFamily: 'Arial',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#313131',
            },
            '& .MuiInputBase-input::placeholder': {
              fontFamily: 'Arial',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#808285',
              opacity: 1,
            },
          }}
          placeholder="Email"
          value={formValues?.email || ''}
          onChange={(e) => onChange('email', e.target.value)}
          error={Boolean(formErrors?.email)}
          helperText={formErrors?.email || ''}
          FormHelperTextProps={{
            sx: {
              ml: 0,
              mt: 0.5,
            },
          }}
        />
      </Grid>

      <Grid item {...fieldGridProps}>
        <Typography
          sx={{
            fontSize: '14px !important',
            fontWeight: 700,
            mb: 1,
            color: '#444444',
          }}
        >
          Associated Business Name
        </Typography>

        <TextField
          fullWidth
          placeholder="Associated Business Name"
          value={formValues?.businessName || ''}
          onChange={(e) => onChange('businessName', e.target.value)}
          sx={{
            '& .MuiInputBase-input': {
              fontFamily: 'Arial',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#313131',
            },
            '& .MuiInputBase-input::placeholder': {
              fontFamily: 'Arial',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#808285',
              opacity: 1,
            },
          }}
        />
      </Grid>

      <Grid item {...fieldGridProps}>
        <Typography
          sx={{
            fontSize: '14px !important',
            fontWeight: 700,
            mb: 1,
            color: '#444444',
          }}
        >
          Contact Name
        </Typography>

        <TextField
          fullWidth
          sx={{
            '& .MuiInputBase-input': {
              fontFamily: 'Arial',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#313131',
            },
            '& .MuiInputBase-input::placeholder': {
              fontFamily: 'Arial',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#808285',
              opacity: 1,
            },
          }}
          placeholder="Contact Name"
          value={formValues?.contactName || ''}
          onChange={(e) => onChange('contactName', e.target.value)}
        />
      </Grid>

      <Grid item xs={12} xl={2}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'flex-end', xl: 'flex-start' },
            flexWrap: 'wrap',
            gap: { xs: 2, sm: 3 },
            // Line the buttons up with the inputs (below the labels) only when they share a row.
            pt: { xs: 0.5, xl: 3.5 },
          }}
        >
          <Link
            component="button"
            underline="none"
            onClick={onClear}
            sx={{
              color: '#52525B',
              fontWeight: 700,
              fontSize: '16px !important',
            }}
          >
            Clear
          </Link>

          <Button
            variant="contained"
            onClick={onSearch}
            disabled={!hasSearchCriteria || Boolean(formErrors?.email) || loading}
            sx={{
              minWidth: 130,
              flex: { xs: 1, sm: 'none' },
              height: 38,
              borderRadius: '30px',
              textTransform: 'none',
              backgroundColor: '#70166F',
              color: '#ffffff',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#5e115d',
              },
            }}
          >
            Search
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}

SearchFilterForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onSearch: PropTypes.func,
};

export default SearchFilterForm;
